import { StateCheckItem } from "./statecheck";

export const checkClass: Array<StateCheckItem> = [
    {
        tag: "duica",
        statecode: "CA",
        message:
            `<strong>Warning</strong> Do not register for this class if you are taking it for a
         CA DMV requirement.
The California DMV does not allow online classes for DUI requirements.
You may be allowed to take our classes for a court requirement.
Please check with your local court for acceptability for your specific case.`,
    },
];
